import { SVGAssets } from '@business/assets/vectors';
import { ContextMenuItem } from '@business/workflows/ComponentUI';
import { useState, useCallback } from 'react';
import { useTrashRestoreDelete } from './TrashRestoreDelete';

const contextMenuIconClassName = 'w-4 h-4 text-[#505050]';
const contextMenuIconClassNameRed = 'w-4 h-4 text-red-600';

export const useMemoryTrashContextMenu = () => {
  const [selectedMemory, setSelectedMemory] = useState<any>(null);
  const [isMemoryDeleteConfirm, setIsMemoryDeleteConfirm] =
    useState<boolean>(false);
  const [restoreMemoryId, setRestoreMemoryId] = useState<string>('');
  const [isMemoryRestoreConfirm, setIsMemoryRestoreConfirm] =
    useState<boolean>(false);

  const { deleteItem, restoreItem } = useTrashRestoreDelete();

  const handleDeleteMemory = (
    memoryId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    deleteItem({
      module: 'memories',
      moduleId: memoryId,
      onSuccess: () => {
        setSelectedMemory(null);
        setIsMemoryDeleteConfirm(false);
        onSuccess?.();
      },
      onError
    });
  };

  const handleRestoreMemory = (
    memoryId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    restoreItem({
      module: 'memories',
      moduleId: memoryId,
      onSuccess: () => {
        setRestoreMemoryId('');
        setIsMemoryRestoreConfirm(false);
        onSuccess?.();
      },
      onError: err => {
        setIsMemoryRestoreConfirm(false);
        onError?.(err);
      }
    });
  };

  const memoryContextMenuItems = useCallback(
    (memory: any) => [
      {
        id: '1',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.ProfileEditIcon className={contextMenuIconClassName} />
            }
            label="Restore"
          />
        ),
        onClick: () => {
          setRestoreMemoryId(memory?.id);
          setIsMemoryRestoreConfirm(true);
        }
      },
      {
        id: '2',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.TrashIcon className={contextMenuIconClassNameRed} />
            }
            label="Delete"
            labelClassName="text-red-600"
          />
        ),
        onClick: () => {
          setSelectedMemory(memory?.id);
          setIsMemoryDeleteConfirm(true);
        }
      }
    ],
    []
  );

  return {
    memoryContextMenuItems,
    selectedMemory,
    setSelectedMemory,
    isMemoryDeleteConfirm,
    setIsMemoryDeleteConfirm,
    restoreMemoryId,
    setRestoreMemoryId,
    isMemoryRestoreConfirm,
    setIsMemoryRestoreConfirm,
    handleDeleteMemory,
    handleRestoreMemory
  };
};
